import { useState } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/authContext";
import {
  useJobsDashboardSaveMutation,
  useMutationJobDelete,
} from "../../actions/dashboardActions";
import { useJobListing } from "../../actions/homeActions";
import { useSelector } from "react-redux";
export default () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.userData.userData);
  const [loadingapi, setLoadingapi] = useState(false);
  const [loadingJobId, setLoadingJobId] = useState(null);
  const per_page = true;
  const isHomepage = true;
  const userId = localStorage.getItem("userId");
  const {
    data: jobslisting,
    isLoading,
    isError,
    error,
  } = useJobListing(per_page, isHomepage, userId);
  const mutation = useJobsDashboardSaveMutation(setLoadingJobId, setLoadingapi);
  const mutationJobDelete = useMutationJobDelete(
    setLoadingJobId,
    setLoadingapi
  );
  const handleJobClick = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (user?.role === "fan") {
      navigate(`/upgrade`);
    } else {
      navigate(`/job-details/${id}`);
    }
  };
  const handleSevedJob = (id, savedJobs) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else if (user?.role === "fan") {
      navigate("/upgrade");
    } else {
      if (savedJobs) {
        setLoadingJobId(id);
        setLoadingapi(true);
        mutationJobDelete.mutate({
          job_id: id,
          user_id: userId,
        });
      } else {
        setLoadingJobId(id);
        setLoadingapi(true);
        mutation.mutate({
          job_id: id,
          user_id: userId,
        });
      }
    }
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading jobs: {error.message}</p>
      </div>
    );
  }
  return {
    jobslisting,
    isLoading,
    handleJobClick,
    loadingJobId,
    handleSevedJob,
  };
};
